import {Component, Input, OnInit} from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { MESSAGE_COMMON_ERROR, MESSAGE_EDIT_SUCCESS } from '../../shared/message';
import { Course } from '../shared/course';
import { CourseUserService } from '../shared/course-user.service';
import { APPCONFIG } from "../../config";

@Component({
  selector: 'app-course-member-item',
  templateUrl: './course-member-item.component.html'
})
export class CourseMemberItemComponent implements OnInit{
  @Input() course: Course;
  @Input() user: any;
  AppConfig: any;

  constructor(private snackBar: MatSnackBar, private refService: CourseUserService) { }

  ngOnInit() {
    this.AppConfig = APPCONFIG;
  }

  get state(): boolean {
    return this.user.state;
  }

  set state(value: boolean) {
    if (this.user.state !== value) {
      this.onSubmit(value);
    }
  }

  async onSubmit(value: boolean) {
    try {
      await this.refService.readRef(this.course.$key, this.user.$key).set({ state: value });
      this.openSnackBar(MESSAGE_EDIT_SUCCESS);
    } catch (e) {
      this.openSnackBar(MESSAGE_COMMON_ERROR);
    }
  }

  private openSnackBar(message: string, action?: string, config?: MatSnackBarConfig) {
    config = Object.assign(new MatSnackBarConfig(), config, { duration: 3000 });
    this.snackBar.open(message, action, config);
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-member-item/course-member-item.component.ts